import { useEffect } from 'react';
import * as appcues from 'neon-appcues';
import { logEvent } from '../utils/logger';
import { useAuth0, useAuth0Data } from 'neon-auth0';
import { useHistory } from 'react-router-dom';
import { config } from '../config';

export const useSetupAppcues = (sessionId: string, env: string, version: string) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const { idToken, accessToken } = useAuth0Data();
  const history = useHistory();

  return useEffect(() => {
    const setupAppcues = () => {
      appcues.init({
        appName: config.appName,
        accessToken: accessToken,
        getAccessToken: getAccessTokenSilently,
        idToken: idToken.__raw,
        log(_message, data) {
          logEvent({ event: 'appcues_init', ...data });
        },
        analyticOptions: {
          env: appcues.environmentResolver(env),
          recordAnalytics: true,
          analyticsOnly: false,
          sessionData: {
            sessionId,
            appName: `Neon ${config.appName}`,
            appVersion: version
          }
        }
      });

      appcues.identify({});
      appcues.analyticsLog({});

      history.listen(appcues.page);
      history.listen((_, __) => appcues.analyticsLog({}));
    };

    if (isAuthenticated && idToken) {
      setupAppcues();
    }
  }, [isAuthenticated, idToken, accessToken, getAccessTokenSilently, history, env, sessionId, version]);
};
